<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar class="nav-bar" :title="$t('个人报表')">
        <template #left>
          <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
        </template>
      </van-nav-bar>
      <div class="info">
        <p class="title">{{ $t('盈利金额') }}</p>
        <p class="value">{{ this.win_money.toFixed(2) }}</p>
        <p class="tip">{{ $t('盈利计算公式 : 中奖金额 - 任务金额') }}</p>
      </div>
      <div class="content">
        <div class="datalist">
          <div class="datalistitem">
            <div class="datalistitemValue">{{ this.personalreport.play_money }}</div>
            <div class="datalistitemKey">{{ $t('任务金额') }}</div>
            <div class="datalistitemRightLine"></div>
          </div>
          <div class="datalistitem">
            <div class="datalistitemValue">{{ this.personalreport.recharge }}</div>
            <div class="datalistitemKey">{{ $t('充值金额') }}</div>
            <div class="datalistitemRightLine"></div>
          </div>
          <div class="datalistitem">
            <div class="datalistitemValue">{{ this.personalreport.withdrawal }}</div>
            <div class="datalistitemKey">{{ $t('提现金额') }}</div>
            <div class="datalistitemRightLine"></div>
          </div>
          <div class="datalistitem">
            <div class="datalistitemValue">{{ this.personalreport.win_money }}</div>
            <div class="datalistitemKey">{{ $t('中奖金额') }}</div>
            <div class="datalistitemRightLine"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      win_money: 0,
      personalreport: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getPersonalreport() {
      this.$http({
        method: 'get',
        url: 'user_get_personalreport'
      }).then(res => {
        if (res.code === 200) {
          this.personalreport = res.data;
          this.win_money = this.personalreport.win_money - this.personalreport.play_money;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getPersonalreport();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container .header {
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}

.container .header .info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 10px;
  margin: auto;
}

.container .header .info .title {
  font-size: 25px;
  color: #e5e5e5;
}

.container .header .info .value {
  margin: 10px auto;
  color: #fff;
  font-size: 50px;
  border-bottom: 1px solid #fff;
}

.container .header .info .tip {
  font-size: 30px;
  color: #e5e5e5;
}

.container .content {
  flex: 1;
  background: #f2f2f5;
}

.container .content .datalist {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.container .content .datalist .datalistitem {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 33.3%;
}

.container .content .datalist .datalistitem .datalistitemValue {
  color: #ff253f;
  font-size: 35px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.container .content .datalist .datalistitem .datalistitemKey {
  color: #979799;
  font-size: 25px;
  margin-bottom: 10px;
  margin-top: 10px;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  // 信息区域PC端适配
  .container .header .info {
    padding-bottom: 11px; /* 20px * 0.5733 ≈ 11px */
    padding-top: 6px; /* 10px * 0.5733 ≈ 6px */
  }

  .container .header .info .title {
    font-size: 14px; /* 25px * 0.5733 ≈ 14px */
  }

  .container .header .info .value {
    margin: 6px auto; /* 10px * 0.5733 ≈ 6px */
    font-size: 29px; /* 50px * 0.5733 ≈ 29px */
  }

  .container .header .info .tip {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  // 数据列表PC端适配
  .container .content .datalist .datalistitem {
    height: 115px; /* 200px * 0.5733 ≈ 115px */
  }

  .container .content .datalist .datalistitem .datalistitemValue {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
    margin-bottom: 6px; /* 10px * 0.5733 ≈ 6px */
    margin-top: 6px; /* 10px * 0.5733 ≈ 6px */
  }

  .container .content .datalist .datalistitem .datalistitemKey {
    font-size: 14px; /* 25px * 0.5733 ≈ 14px */
    margin-bottom: 6px; /* 10px * 0.5733 ≈ 6px */
    margin-top: 6px; /* 10px * 0.5733 ≈ 6px */
  }
}
</style>
